import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Divisibilite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nb: Math.floor(Math.random() * (9999 - 20 + 1) + 20),
      randomDiv: Math.floor(Math.random() * 12),
      divisibleTab: [
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "9",
        "10",
        "11",
        "13",
        "15",
        "17",
      ],
      answer: 2,
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerDivisibilite = (event) => {
    event.preventDefault();
    var res = this.state.nb / this.state.divisibleTab[this.state.randomDiv];
    var isInteger = Number.isInteger(res);
    if (isInteger === true && this.state.answer === 1) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.nb +
          " divisible par " +
          this.state.divisibleTab[this.state.randomDiv] +
          " (" +
          this.state.nb +
          "/" +
          this.state.divisibleTab[this.state.randomDiv] +
          " = " +
          res +
          ")",
      });
    } else if (isInteger === false && this.state.answer === 0) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.nb +
          " non divisible par " +
          this.state.divisibleTab[this.state.randomDiv] +
          " (" +
          this.state.nb +
          "/" +
          this.state.divisibleTab[this.state.randomDiv] +
          " = " +
          res +
          ")",
      });
    } else if (isInteger === true && this.state.answer === 0) {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.nb +
          " divisible par " +
          this.state.divisibleTab[this.state.randomDiv] +
          " (" +
          this.state.nb +
          "/" +
          this.state.divisibleTab[this.state.randomDiv] +
          " = " +
          res +
          ")",
      });
    } else if (isInteger === false && this.state.answer === 1) {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.nb +
          " non divisible par " +
          this.state.divisibleTab[this.state.randomDiv] +
          " (" +
          this.state.nb +
          "/" +
          this.state.divisibleTab[this.state.randomDiv] +
          " = " +
          res +
          ")",
      });
    }
    var n = Math.floor(Math.random() * (9999 - 20 + 1) + 20);
    var randD = Math.floor(Math.random() * 12);
    this.setState({ nb: n, randomDiv: randD, answer: 2 });
  };

  myChangeHandlerYes = (event) => {
    this.setState({ answer: 1 });
  };
  myChangeHandlerNo = (event) => {
    this.setState({ answer: 0 });
  };

  render() {
    return (
      <div className="App">
        <div className="navigation">
          <img
            className="website-logo"
            src={logo}
            alt="Logo Mathis Admission"
          />
          <h1 className="website-title-text">Prepa Tage Mage</h1>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col">
            <h2 className="menu-principal-text">Critère de divisibilité</h2>
          </div>
        </div>

        <div className="container">
          <p className={this.state.messageColor}>{this.state.message}</p>
          <form
            className="col"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onSubmit={this.mySubmitHandlerDivisibilite}
          >
            <label className="label-exos">
              {this.state.nb} divisible par{" "}
              {this.state.divisibleTab[this.state.randomDiv]} ?{" "}
            </label>
            <div className="row">
              <input
                className="answer-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Oui"
                onClick={this.myChangeHandlerYes}
              />
              <input
                className="answer-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Non"
                onClick={this.myChangeHandlerNo}
              />
            </div>
          </form>
          <p class="help-txt">Besoin d'un peu d'aide ? Scroll la page pour voir le cours ;)</p>

        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col-12 col-lg-4">
            <a className="all-button" href="/">
              Retour au menu
            </a>
          </div>
        </div>

        <div class="rappel">
            <h3>Rappel de cours :</h3>
            <div className="container">
              <p>
                <strong>0</strong>&nbsp;est divisible par{" "}
                &nbsp;<strong>tous les nombres</strong>
              </p>
              <p>
                <strong>/2</strong>&nbsp;si le nombre est
                &nbsp;<strong> pair</strong>
              </p>
              <p>
                <strong>/3</strong>&nbsp;si la&nbsp;<strong>somme des chiffres&nbsp;</strong> du
                nombre est divisible par
                &nbsp;<strong> 3</strong>
              </p>
              <p>
                <strong>/4</strong>&nbsp;si le nombre formé par{" "}
                &nbsp;<strong>les deux derniers chiffres&nbsp;</strong>
                est divisible par&nbsp;<strong>4</strong>
              </p>
              <p>
                <strong>/5</strong>&nbsp;si le nombre se{" "}
                &nbsp;<strong>termine par 0 ou 5</strong>
              </p>
              <p>
                <strong>/6</strong>&nbsp;si la&nbsp;<strong>somme des chiffres</strong>&nbsp;du
                nombre est{" "}
                &nbsp;<strong>divisible par 3 et que c’est un nombre pair</strong>
              </p>
              <p>
                <strong>/7</strong>&nbsp;si&nbsp;<strong>Dizaine – 2xUnité</strong>&nbsp;est{" "}
                &nbsp;<strong>divisible par 7</strong>
              </p>
              <p>
                <strong>/9</strong>&nbsp;si la&nbsp;<strong>somme des chiffres&nbsp;</strong> du
                nombre est&nbsp;<strong>divisible par 9</strong>
              </p>
              <p>
                <strong>/10</strong>&nbsp;si le nombre se&nbsp;<strong>termine par 0</strong>
              </p>
              <p>
                <strong>/11</strong>&nbsp;pour un nombre de 3 chiffres (CDU) alors{" "}
                &nbsp;<strong>C+U = D</strong>
              </p>
              <p>
                <strong>/13</strong>&nbsp;si&nbsp;<strong>Dizaine + 4xUnité&nbsp;</strong> est{" "}
                &nbsp;<strong>divisible par 13</strong>
              </p>
              <p>
                <strong>/15</strong>&nbsp;si la&nbsp;<strong>somme des chiffres</strong>&nbsp;du
                nombre est
                &nbsp;<strong> divisible par 3</strong>&nbsp;et que le nombre{" "}
                &nbsp;<strong>se termine par 0 ou 5</strong>
              </p>
              <p>
                <strong>/17</strong>&nbsp;si&nbsp;<strong>Dizaine - 5xUnité</strong>&nbsp;est{" "}
                <strong>divisible par 17</strong>
              </p>
            </div>
          </div>
      </div>
    );
  }
}

export default Divisibilite;
